<div class="card stat-card" [ngStyle]="{ 'background-color': data.bgColor }">
  <div class="card-content">
    <div class="card-title" [innerHTML]="formattedTitle"></div>
    <div class="card-value">{{ stat }}</div>
  </div>
</div>
